import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';

export interface WalletManagementState {
  totalRecords: number | null;
  data: [] | null;
  totalPages: number | null;
  currentPage: number | null;
}

const initialState: WalletManagementState = {
  totalRecords: null,
  data: null,
  totalPages: null,
  currentPage: null,
};

export const walletManagementSlice = createSlice({
  name: 'walletMangement',
  initialState,
  reducers: {
    setWalletManagement: (state, action) => {
      state.data = action.payload.data;
      state.currentPage = action.payload.currentPage;
      state.totalPages = action.payload.totalPages;
      state.totalRecords = action.payload.totalRecords;
    },
    addNewWalletManagement: (state: any, action) => {
      state.data = [action.payload.data, ...state.data];
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

export const { setWalletManagement, addNewWalletManagement, reset } = walletManagementSlice.actions;
export const getWalletManagement = (state: RootState) => state.walletManagement.data;
export const getWalletManagementTotalRecord = (state: RootState) => state.walletManagement.totalRecords;
export default walletManagementSlice.reducer;
